import React from 'react'
import { Panel } from '@pga/pga-component-library'
import { Col, Container, Row } from 'reactstrap'
import { PanelContentContainer } from '../shared.styles'

const PaymentPanel = ({ children }) => (
  <Container className='mt-5'>
    <Row>
      <Col sm='12' md={{ size: 8, offset: 2 }}>
        <Panel>
          <PanelContentContainer>
            {children}
          </PanelContentContainer>
        </Panel>
      </Col>
    </Row>
  </Container>
)

export default PaymentPanel
